import IssuesBanner from "components/IssuesBanner";
import NewBillingPageBanner from "./NewBillingPageBanner";
import NewDashboardDesignAvailableBanner from "./NewDashboardDesignAvailableBanner";
import AccountPendingRemovalBanner from "./AccountPendingRemovalBanner";

import { useNewDashboardDesign } from "hooks/useNewDashboardDesign";
import { cx } from "utils";


export default function TopBanners() {
  const { newDashboardDesignSetting } = useNewDashboardDesign();
  const darkModeForTopBanners = (newDashboardDesignSetting === "yes");

  return (
    <div className={ cx("flex flex-col", darkModeForTopBanners && "dark") }>
      <AccountPendingRemovalBanner />
      <NewDashboardDesignAvailableBanner />
      <NewBillingPageBanner />
      <IssuesBanner />
    </div>
  );
};
